import { LOG_OUT } from "../login/action";
import {
  SET_PROFILE_STATES,
  SHOW_PROFILE_DRIVER_BIRTHDAY_MODAL,
  HIDE_PROFILE_DRIVER_BIRTHDAY_MODAL,
  SHOW_PROFILE_DRIVER_LICENSE_MODAL,
  HIDE_PROFILE_DRIVER_LICENSE_MODAL,
  SHOW_PROFILE_DRIVER_EMAIL_MODAL,
  HIDE_PROFILE_DRIVER_EMAIL_MODAL,
  SHOW_PROFILE_DRIVER_ADDRESS_MODAL,
  HIDE_PROFILE_DRIVER_ADDRESS_MODAL,
  SHOW_PROFILE_DRIVER_PHONE_MODAL,
  HIDE_PROFILE_DRIVER_PHONE_MODAL,
  SHOW_PROFILE_DRIVER_VEHICLE_OPTIONS_MODAL,
  HIDE_PROFILE_DRIVER_VEHICLE_OPTIONS_MODAL,
  SHOW_PROFILE_DRIVER_EMAIL_OPTIONS_MODAL,
  HIDE_PROFILE_DRIVER_EMAIL_OPTIONS_MODAL,
  SHOW_PROFILE_DRIVER_ADDRESS_OPTIONS_MODAL,
  HIDE_PROFILE_DRIVER_ADDRESS_OPTIONS_MODAL,
  SHOW_PROFILE_DRIVER_PHONE_OPTIONS_MODAL,
  HIDE_PROFILE_DRIVER_PHONE_OPTIONS_MODAL,
  PROFILE_DRIVER_ADD_NEW_VEHICLE,
  PROFILE_DRIVER_ADD_NEW_EMAIL,
  PROFILE_DRIVER_ADD_NEW_ADDRESS,
  PROFILE_DRIVER_ADD_NEW_PHONE,
  PROFILE_DRIVER_EDIT_VEHICLE_API,
  PROFILE_DRIVER_EDIT_EMAIL_API,
  PROFILE_DRIVER_EDIT_ADDRESS_API,
  PROFILE_DRIVER_EDIT_PHONE_API,
  SHOW_PROFILE_DRIVER_EDIT_VEHICLE_MODAL,
  SHOW_PROFILE_DRIVER_EDIT_EMAIL_MODAL,
  SHOW_PROFILE_DRIVER_EDIT_ADDRESS_MODAL,
  SHOW_PROFILE_DRIVER_EDIT_PHONE_MODAL,
  HIDE_PROFILE_DRIVER_EDIT_VEHICLE_MODAL,
  HIDE_PROFILE_DRIVER_EDIT_EMAIL_MODAL,
  HIDE_PROFILE_DRIVER_EDIT_ADDRESS_MODAL,
  HIDE_PROFILE_DRIVER_EDIT_PHONE_MODAL,
  GET_PROFILE_VEHICLE_MAKE_STATES,
  SET_PROFILE_VEHICLE_MAKE_STATES,
  PROFILE_DRIVER_EDIT_DOB_API,
  PROFILE_DRIVER_GET_STYLING_API,
  PROFILE_DRIVER_SET_STYLING_API,
  SHOW_PROFILE_DRIVER_DELETE_EMAIL_MODAL,
  HIDE_PROFILE_DRIVER_DELETE_EMAIL_MODAL,
  SHOW_PROFILE_DRIVER_DELETE_ADDRESS_MODAL,
  HIDE_PROFILE_DRIVER_ADD_VEHICLE_MODAL,
  SHOW_PROFILE_DRIVER_ADD_VEHICLE_MODAL,
  SHOW_PROFILE_DRIVER_MANAGE_VEHICLE_MODAL,
  HIDE_PROFILE_DRIVER_MANAGE_VEHICLE_MODAL,
  SHOW_PROFILE_DRIVER_DELETE_VEHICLE_MODAL,
  HIDE_PROFILE_DRIVER_DELETE_VEHICLE_MODAL,
  GET_PROFILE_VEHICLE_DETAILS,
  SET_PROFILE_VEHICLE_DETAILS,
  GET_PROFILE_EMAIL_DETAILS,
  SET_PROFILE_EMAIL_DETAILS,
  GET_PROFILE_ADDRESS_DETAILS,
  SET_PROFILE_ADDRESS_DETAILS,
  GET_PROFILE_PHONE_DETAILS,
  SET_PROFILE_PHONE_DETAILS,
  HIDE_PROFILE_DRIVER_UPDATE_USERNAME_MODAL,
  SHOW_PROFILE_DRIVER_UPDATE_USERNAME_MODAL,
  SET_STATES,
  SET_MY_ACCOUNT_EDITOR_DATA,
  SET_REVIEW_AND_ORDER_EDITOR_DATA,
  SET_PAYMENT_PAGE_EDITOR_DATA,
  SET_CHECKBOX_AGREEMENT_TEXT_EDITOR_DATA,
  SET_ORDER_COMPLETE_PAGE_EDITOR_DATA,
  SET_CITATION_INFORMATION_EDITOR_DATA,
  SET_CITATION_DETAILS_PAGE_EDITOR_DATA,
  SET_PAYMENT_TEXT_CITATION_EDITOR_DATA,
  SET_PAYMENT_ACCEPTED_TEXT_CITATION_EDITOR_DATA,
  SET_TERMS_OF_USES_EDITOR_DATA,
  SET_APPEAL_FINE_HEADER_EDITOR_DATA,
  SET_NEW_ORDER_PERMIT_DATA,
  SET_ACCOUNT_VEHICLE_DETAILS,
  PROFILE_DRIVER_ADD_NEW_BILLING_ADDRESS,
  SHOW_PROFILE_DRIVER_VEHICLE_DOCUMENTS_MODAL,
  HIDE_PROFILE_DRIVER_VEHICLE_DOCUMENTS_MODAL,
  SHOW_PROFILE_DRIVER_UPLOAD_DOCUMENTS_MODAL,
  HIDE_PROFILE_DRIVER_UPLOAD_DOCUMENTS_MODAL,
  SET_PROFILE_VEHICLE_DOCUMENTS,
  SET_PROFILE_DRIVER_VEHICLE_DOCUMENT_SETTINGS,
} from "./action";

export const defaultState = {
  profileStateList: [],
  profileDriverBirthdayModalState: false,
  profileDriverLicenseModalState: false,
  profileDriverEmailModalState: false,
  profileDriverAddressModalState: false,
  profileDriverPhoneModalState: false,
  profileDriverVehicleOptionsModalState: false,
  profileDriverEmailOptionsModalState: false,
  profileDriverAddressOptionsModalState: false,
  profileDriverPhoneOptionsModalState: false,
  profileDriverAddNewVehicleState: [],
  profileDriverAddNewEmailState: [],
  profileDriverAddNewAddressState: [],
  profileDriverAddNewBillingAddressState: [],
  profileDriverEditPhoneApiState: [],
  profileDriverEditVehicleApiState: [],
  profileDriverEditEmailApiState: [],
  profileDriverEditAddressApiState: [],
  accountDriverVehicleDetails:undefined,
  //DOB

  profileDriverEditDOBApiState: [],
  profileDriverEditVehicleModalState: false,
  profileDriverEditEmailModalState: false,
  profileDriverdDeleteEmailModalState: false,
  profileDriverdDeleteAddressModalState: false,
  profileDriverEditAddressModalState: false,
  profileDriverEditPhoneModalState: false,
  SelectedEmail: "",
  selectedVehicle: "",
  SelectedAddress: "",
  SelectedPhone: "",
  profileVehicleMakeList: [],
  profileDriverCloseAddVehicleModel: false,
  profileDriverCloseManageVehicleModal:false,
  profileDriverDeleteVehicleModel: false,
  profileDriverUpdateUsernameModalState: false,
  //    get driver styling
  profileDriverSetStyling: "",
  profileDriverGetVehicleDetails: [],

  profileDriverGetEmailDetails: [],
  profileDriverGetAddressDetails: [],
  profileDriverGetPhoneDetails: [],
  states: [],
  myAccountEditorData: "",
  reviewAndOrderEditorData: "",
  paymentPageEditorData: "",
  checkboxAgreementTextEditorData: "",
  orderCompletePageEditorData: "",
  citationInformationPageEditorData: "",
  newOrderPermitPageEditorData: "",
  citationDetailsPageEditorData: "",
  paymentTextCitationEditorData: "",
  paymentAcceptedTextCitationEditorData: "",
  appealFineHeaderEditorData: "",
  termsOfUsesEditorData: "",
  profileDriverVehicleDocumentsModalState: false,
  profileDriverUploadDocumentsModalState: false,
  vehicleDocuments: [],
  vehicleDocumentSettings: undefined,
};

function profileReducer(state = defaultState, action) {
  switch (action.type) {
    // update address earphone
    case HIDE_PROFILE_DRIVER_UPDATE_USERNAME_MODAL:
      return {
        ...state,
        profileDriverUpdateUsernameModalState: false,
      };

    case SHOW_PROFILE_DRIVER_UPDATE_USERNAME_MODAL:
      return {
        ...state,
        profileDriverUpdateUsernameModalState: true,
      };
    case SHOW_PROFILE_DRIVER_DELETE_VEHICLE_MODAL:
      return {
        ...state,
        profileDriverDeleteVehicleModel: true,
      };
    case HIDE_PROFILE_DRIVER_DELETE_VEHICLE_MODAL:
      return {
        ...state,
        profileDriverDeleteVehicleModel: false,
      };
      case SHOW_PROFILE_DRIVER_MANAGE_VEHICLE_MODAL:
        return {
          ...state,
          profileDriverCloseManageVehicleModal:true,
        };
      case HIDE_PROFILE_DRIVER_MANAGE_VEHICLE_MODAL:
        return {
          ...state,
          profileDriverCloseManageVehicleModal:false,
        };
    case SHOW_PROFILE_DRIVER_ADD_VEHICLE_MODAL:
      return {
        ...state,
        profileDriverCloseAddVehicleModel: true,
      };
    case HIDE_PROFILE_DRIVER_ADD_VEHICLE_MODAL:
      return {
        ...state,
        profileDriverCloseAddVehicleModel: false,
      };
    case PROFILE_DRIVER_GET_STYLING_API:
      return {
        ...state,
      };
    case PROFILE_DRIVER_SET_STYLING_API:
      return {
        ...state,
        profileDriverSetStyling: action.payload,
      };
    case SET_PROFILE_STATES:
      return {
        ...state,
        profileStateList: action.payload,
      };
    case SHOW_PROFILE_DRIVER_BIRTHDAY_MODAL:
      return {
        ...state,
        profileDriverBirthdayModalState: true,
      };
    case HIDE_PROFILE_DRIVER_BIRTHDAY_MODAL:
      return {
        ...state,
        profileDriverBirthdayModalState: false,
      };
    case SHOW_PROFILE_DRIVER_LICENSE_MODAL:
      return {
        ...state,
        profileDriverLicenseModalState: true,
      };
    case HIDE_PROFILE_DRIVER_LICENSE_MODAL:
      return {
        ...state,
        profileDriverLicenseModalState: false,
      };
    case SHOW_PROFILE_DRIVER_EMAIL_MODAL:
      return {
        ...state,
        profileDriverEmailModalState: true,
      };
    case HIDE_PROFILE_DRIVER_EMAIL_MODAL:
      return {
        ...state,
        profileDriverEmailModalState: false,
      };
    case SHOW_PROFILE_DRIVER_ADDRESS_MODAL:
      return {
        ...state,
        profileDriverAddressModalState: true,
      };
    case HIDE_PROFILE_DRIVER_ADDRESS_MODAL:
      return {
        ...state,
        profileDriverAddressModalState: false,
      };
    case SHOW_PROFILE_DRIVER_PHONE_MODAL:
      return {
        ...state,
        profileDriverPhoneModalState: true,
      };
    case HIDE_PROFILE_DRIVER_PHONE_MODAL:
      return {
        ...state,
        profileDriverPhoneModalState: false,
      };
    case SHOW_PROFILE_DRIVER_VEHICLE_OPTIONS_MODAL:
      return {
        ...state,
        profileDriverVehicleOptionsModalState: true,
        selectedVehicle: action.payload,
      };
    case HIDE_PROFILE_DRIVER_VEHICLE_OPTIONS_MODAL:
      return {
        ...state,
        profileDriverVehicleOptionsModalState: false,
      };
    case SHOW_PROFILE_DRIVER_EMAIL_OPTIONS_MODAL:
      return {
        ...state,
        profileDriverEmailOptionsModalState: true,
        SelectedEmail: action.payload,
      };
    case HIDE_PROFILE_DRIVER_EMAIL_OPTIONS_MODAL:
      return {
        ...state,
        profileDriverEmailOptionsModalState: false,
      };
    case SHOW_PROFILE_DRIVER_ADDRESS_OPTIONS_MODAL:
      return {
        ...state,
        profileDriverAddressOptionsModalState: true,
        SelectedAddress: action.payload,
      };
    case HIDE_PROFILE_DRIVER_ADDRESS_OPTIONS_MODAL:
      return {
        ...state,
        profileDriverAddressOptionsModalState: false,
      };
    case SHOW_PROFILE_DRIVER_PHONE_OPTIONS_MODAL:
      return {
        ...state,
        profileDriverPhoneOptionsModalState: true,
        SelectedPhone: action.payload,
      };
    case HIDE_PROFILE_DRIVER_PHONE_OPTIONS_MODAL:
      return {
        ...state,
        profileDriverPhoneOptionsModalState: false,
      };
    case PROFILE_DRIVER_ADD_NEW_VEHICLE:
      return {
        ...state,
        profileDriverAddNewVehicleState: action.payload,
      };
    case PROFILE_DRIVER_ADD_NEW_EMAIL:
      return {
        ...state,
        profileDriverAddNewEmailState: action.payload,
      };
    case PROFILE_DRIVER_ADD_NEW_ADDRESS:
      return {
        ...state,
        profileDriverAddNewAddressState: action.payload,
      };
    case PROFILE_DRIVER_ADD_NEW_BILLING_ADDRESS:
      return {
        ...state,
        profileDriverAddNewBillingAddressState : action.payload,
      }
    case PROFILE_DRIVER_ADD_NEW_PHONE:
      return {
        ...state,
        profileDriverAddNewPhoneState: action.payload,
      };
    case PROFILE_DRIVER_EDIT_VEHICLE_API:
      return {
        ...state,
        profileDriverEditVehicleApiState: action.payload,
      };
    case PROFILE_DRIVER_EDIT_EMAIL_API:
      return {
        ...state,
        profileDriverEditEmailApiState: action.payload,
      };

    // Update DOB
    case PROFILE_DRIVER_EDIT_DOB_API:
      return {
        ...state,
        profileDriverEditDOBApiState: action.payload,
      };

    case PROFILE_DRIVER_EDIT_ADDRESS_API:
      return {
        ...state,
        profileDriverEditAddressApiState: action.payload,
      };
    case PROFILE_DRIVER_EDIT_PHONE_API:
      return {
        ...state,
        profileDriverEditPhoneApiState: action.payload,
      };
    case HIDE_PROFILE_DRIVER_EDIT_VEHICLE_MODAL:
      return {
        ...state,
        profileDriverEditVehicleModalState: false,
      };
    case HIDE_PROFILE_DRIVER_EDIT_EMAIL_MODAL:
      return {
        ...state,
        profileDriverEditEmailModalState: false,
      };
    case HIDE_PROFILE_DRIVER_DELETE_EMAIL_MODAL:
      return {
        ...state,
        profileDriverdDeleteEmailModalState: false,
      };
    case HIDE_PROFILE_DRIVER_EDIT_ADDRESS_MODAL:
      return {
        ...state,
        profileDriverEditAddressModalState: false,
      };
    case HIDE_PROFILE_DRIVER_EDIT_PHONE_MODAL:
      return {
        ...state,
        profileDriverEditPhoneModalState: false,
      };
    case SHOW_PROFILE_DRIVER_EDIT_VEHICLE_MODAL:
      return {
        ...state,
        profileDriverEditVehicleModalState: true,
      };
    case SHOW_PROFILE_DRIVER_EDIT_EMAIL_MODAL:
      return {
        ...state,
        profileDriverEditEmailModalState: true,
      };

    // SHOW DELETE MODEL ON  UPDATE ADDRESS
    case SHOW_PROFILE_DRIVER_DELETE_ADDRESS_MODAL:
      return {
        ...state,
        profileDriverdDeleteAddressModalState: true,
      };
    case SHOW_PROFILE_DRIVER_DELETE_EMAIL_MODAL:
      return {
        ...state,
        profileDriverdDeleteEmailModalState: true,
      };
    case SHOW_PROFILE_DRIVER_EDIT_ADDRESS_MODAL:
      return {
        ...state,
        profileDriverEditAddressModalState: true,
      };
    case SHOW_PROFILE_DRIVER_EDIT_PHONE_MODAL:
      return {
        ...state,
        profileDriverEditPhoneModalState: true,
      };
    case GET_PROFILE_VEHICLE_MAKE_STATES:
      return {
        ...state,
      };
    case SET_PROFILE_VEHICLE_MAKE_STATES:
      return {
        ...state,
        profileVehicleMakeList: action.payload,
      };
    case GET_PROFILE_VEHICLE_DETAILS:
      return {
        ...state,
        // profileDriverGetVehicleDetails: action.payload,
      };
    case SET_PROFILE_VEHICLE_DETAILS:
      return {
        ...state,
        profileDriverGetVehicleDetails: action.payload,
      };
    // case SET_ACCOUNT_VEHICLE_DETAILS:
    //   return {
    //     ...state
    //   };
    case SET_ACCOUNT_VEHICLE_DETAILS:
      return {
        ...state,
        accountDriverVehicleDetails: action.payload,
      };
    case GET_PROFILE_EMAIL_DETAILS:
      return {
        ...state,
        // profileDriverGetEmailDetails: action.payload,
      };
    case SET_PROFILE_EMAIL_DETAILS:
      return {
        ...state,
        profileDriverGetEmailDetails: action.payload,
      };
    case GET_PROFILE_ADDRESS_DETAILS:
      return {
        ...state,
        // profileDriverGetAddressDetails: action.payload,
      };
    case SET_PROFILE_ADDRESS_DETAILS:
      return {
        ...state,
        profileDriverGetAddressDetails: action.payload,
      };
    case GET_PROFILE_PHONE_DETAILS:
      return {
        ...state,
        // profileDriverGetPhoneDetails: action.payload,
      };
    case SET_PROFILE_PHONE_DETAILS:
      return {
        ...state,
        profileDriverGetPhoneDetails: action.payload,
      };
    case SET_STATES:
      return {
        ...state,
        states: action.payload,
      };
    case SET_MY_ACCOUNT_EDITOR_DATA:
      return {
        ...state,
        myAccountEditorData: action.payload,
      };
    case SET_REVIEW_AND_ORDER_EDITOR_DATA:
      return {
        ...state,
        reviewAndOrderEditorData: action.payload,
      };
    case SET_PAYMENT_PAGE_EDITOR_DATA:
      return {
        ...state,
        paymentPageEditorData: action.payload,
      };
    case SET_CHECKBOX_AGREEMENT_TEXT_EDITOR_DATA:
      return {
        ...state,
        checkboxAgreementTextEditorData: action.payload,
      };
    case SET_ORDER_COMPLETE_PAGE_EDITOR_DATA:
      return {
        ...state,
        orderCompletePageEditorData: action.payload,
      };
    case SET_CITATION_INFORMATION_EDITOR_DATA:
      return {
        ...state,
        citationInformationPageEditorData: action.payload,
      };
    // new order
    case SET_NEW_ORDER_PERMIT_DATA:
      return {
        ...state,
        newOrderPermitPageEditorData: action.payload,
      };
    case SET_CITATION_DETAILS_PAGE_EDITOR_DATA:
      return {
        ...state,
        citationDetailsPageEditorData: action.payload,
      };
    case SET_PAYMENT_TEXT_CITATION_EDITOR_DATA:
      return {
        ...state,
        paymentTextCitationEditorData: action.payload,
      };
    case SET_PAYMENT_ACCEPTED_TEXT_CITATION_EDITOR_DATA:
      return {
        ...state,
        paymentAcceptedTextCitationEditorData: action.payload,
      };
    case SET_APPEAL_FINE_HEADER_EDITOR_DATA:
      return {
        ...state,
        appealFineHeaderEditorData: action.payload,
      };
    case SET_TERMS_OF_USES_EDITOR_DATA:
      return {
        ...state,
        termsOfUsesEditorData: action.payload,
      };
    case SHOW_PROFILE_DRIVER_VEHICLE_DOCUMENTS_MODAL:
      return {
        ...state,
        profileDriverVehicleDocumentsModalState: true,
        selectedVehicle: action.payload,
      };
    case HIDE_PROFILE_DRIVER_VEHICLE_DOCUMENTS_MODAL:
      return {
        ...state,
        profileDriverVehicleDocumentsModalState: false,
      };
    case SHOW_PROFILE_DRIVER_UPLOAD_DOCUMENTS_MODAL:
      return {
        ...state,
        profileDriverUploadDocumentsModalState: true,
      };
    case HIDE_PROFILE_DRIVER_UPLOAD_DOCUMENTS_MODAL:
      return {
        ...state,
        profileDriverUploadDocumentsModalState: false,
      };
    case SET_PROFILE_VEHICLE_DOCUMENTS:
      return {
        ...state,
        vehicleDocuments: action.payload,
      };
    case SET_PROFILE_DRIVER_VEHICLE_DOCUMENT_SETTINGS:
      return {
        ...state,
        vehicleDocumentSettings: action.payload,
      };
    case LOG_OUT:
      return defaultState;
    default:
      return state;
  }
}

export default profileReducer;
